module.exports = __webpack_public_path__ + "static/media/darkWaglLogo.e44adcac.svg";